export const SYNONYM_BLACKLIST = [
  "Kultur", "Musik", "Kunst", "Filme", "Film", "Theater", "Literatur", "Wissenschaft", "Forschung", "Wissen", "Sport", "Fußball", "Fitness", "Bundesliga", "Wirtschaft", "Finanzen", "Deutschland", "Politik"
]